export default __webpack_public_path__ + "static/media/normalCabinet.6949249d.png";